import { ICompositeProductApi } from '@canvas-logic/clp-sdk';
import { IUICfgAttributeText } from '@canvas-logic/clp-api-types';
import { AttributeStateBase } from '@/elements/base/AttributeStateBase';

let id = 0;

export class TextAttributeState extends AttributeStateBase<IUICfgAttributeText, string> {
  readonly elementKind = 'attribute';
  readonly elementType = 'text';
  public id = 'text-view-state-' + ++id;

  constructor(api: ICompositeProductApi, element: IUICfgAttributeText) {
    super(api, element);
    this.initValueState();
  }
}
